var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomElectricityOutlet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M0 0h15v25H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M.5.5h14v24H.5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M4.671 12C3.651 11.057 3 9.616 3 8s.652-3.057 1.671-4h5.658C11.349 4.943 12 6.384 12 8s-.652 3.057-1.671 4H4.67z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M4.873 11.5h5.254C10.99 10.627 11.5 9.364 11.5 8c0-1.364-.51-2.627-1.373-3.5H4.873C4.01 5.373 3.5 6.636 3.5 8c0 1.364.51 2.627 1.373 3.5zM6.5 6v2M7.5 9v1M8.5 6v2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M4.671 21C3.651 20.057 3 18.616 3 17s.652-3.057 1.671-4h5.658c1.02.943 1.671 2.384 1.671 4s-.652 3.057-1.671 4H4.67z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M4.873 20.5h5.254c.863-.873 1.373-2.136 1.373-3.5 0-1.364-.51-2.627-1.373-3.5H4.873C4.01 14.373 3.5 15.636 3.5 17c0 1.364.51 2.627 1.373 3.5zM6.5 15v2M7.5 18v1M8.5 15v2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomElectricityOutlet);
export default __webpack_public_path__ + "static/media/RoomElectricityOutlet.45c20d72df431a5bf87c67e7f1d03ba6.svg";
export { ForwardRef as ReactComponent };